import { INTERACTION_STATE_OPEN, VARIANT_WITH_ICON, VARIANT_WITH_LINK, ELEMENT_OPEN_TRIGGER, ELEMENT_HEADING, ELEMENT_CLOSE_BUTTON, ELEMENT_CARD, } from '../../constants';
import getIcons from '../../icons/icons.alias';
import { constants as IconButton } from '../IconButton';
import { constants as Link } from '../Link';
import { constants as Heading } from '../Heading';
import { getBoxShadow } from '../../shadows/shadows.alias';
import { getBackgroundColor, getBorderColor, getColor, } from '../../colors/colors.alias';
export const constants = Object.freeze({
    NAME: 'Popover',
    variants: {
        VARIANT_WITH_ICON,
        VARIANT_WITH_LINK,
    },
    interactionStates: {
        INTERACTION_STATE_OPEN,
    },
    elements: {
        ELEMENT_CARD,
        ELEMENT_CLOSE_BUTTON,
        ELEMENT_HEADING,
        ELEMENT_OPEN_TRIGGER,
    },
});
export default function getPopover(transformer, config) {
    const boxShadow = getBoxShadow(transformer, config);
    const color = getColor(transformer, config);
    const icons = getIcons();
    const backgroundColor = getBackgroundColor(transformer, config);
    const borderColor = getBorderColor(transformer, config);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_OPEN_TRIGGER]: {
                variants: {
                    [VARIANT_WITH_ICON]: {
                        components: {
                            [IconButton.NAME]: {
                                variant: IconButton.variants.VARIANT_PLAIN_MEDIUM,
                                iconName: icons.feedback.informative.value,
                            },
                        },
                        styles: {
                            color: color.text.default.value,
                        },
                    },
                    [VARIANT_WITH_LINK]: {
                        components: {
                            [Link.NAME]: {
                                variant: Link.variants.VARIANT_INFO,
                            },
                        },
                    },
                },
            },
            [ELEMENT_CARD]: {
                styles: {
                    borderColor: borderColor.popover.value,
                    backgroundColor: backgroundColor.contentContainer.plain.default.value,
                    boxShadow: boxShadow.container.value,
                    borderWidth: '1px',
                    borderStyle: 'solid',
                },
            },
            [ELEMENT_HEADING]: {
                components: {
                    [Heading.NAME]: {
                        variant: Heading.variants.VARIANT_SMALL,
                    },
                },
            },
            [ELEMENT_CLOSE_BUTTON]: {
                components: {
                    [IconButton.NAME]: {
                        variant: IconButton.variants.VARIANT_PLAIN_MEDIUM,
                        iconName: icons.action.close.value,
                    },
                },
            },
        },
    });
}
